import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse } from '../../shared/config';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'wego-forgotpassword',
  template: require('../views/changepasswordsuccess.component.html'),
  styles: [`.headerror {
                font-size: 150px !important;
                font-weight: normal;
                line-height: 100px;
                margin-top: 50px;
                color: #2ba2aa;
          }`]
})

export class ChangePasswordSuccessComponent implements OnInit, OnDestroy {
  constructor() {

  }
  ngOnInit() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      // Redirect to deep link for mobile app
      window.location.href = 'wego://carsharing/';
    }
  }
  ngOnDestroy() { console.log('ngOnDestroy'); }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/forgotpassword/components/changepasswordsuccess.component.ts